import Model from '@/class/cargo/model/utils/Model'

export class SpecialPriceSaleState {
  constructor(code, englishName, chineseName) {
    this.code = code
    this.chineseName = chineseName
    this.englishName = englishName
  }
}

export const CODE_NAME = 'SpecialPriceSaleState'

export const ALL = new SpecialPriceSaleState(-1, 'All', '全部')

export const NO_APPLY_SPECIALP_RICE = new SpecialPriceSaleState(0, 'NoApplySpecialPrice', '不允许申请特价')

export const APPLY_SPECIALP_RICE = new SpecialPriceSaleState(1, 'ApplySpecialPrice', '允许申请特价')
export const SPECIAL_PRICE = new SpecialPriceSaleState(2, 'SpecialPrice', '特价')
export const NO_SPECIAL_PRICE = new SpecialPriceSaleState(3, 'NoSpecialPrice', ' ')

// 运价日期类型
export const SALE_STATE_TYPES = [NO_APPLY_SPECIALP_RICE, APPLY_SPECIALP_RICE, SPECIAL_PRICE, NO_SPECIAL_PRICE]
export const SALE_STATE_TYPES_All = [ALL, NO_APPLY_SPECIALP_RICE, APPLY_SPECIALP_RICE, SPECIAL_PRICE, NO_SPECIAL_PRICE]

/**
		 *  return null:没找到.
		 */
export function getPriceSaleStateByCode(code) {
  return Model.getObjByCode(code, SALE_STATE_TYPES)
}
